import { $themeBreakpoints } from '@themeConfig'
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    adminData: [],
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
    getOptions: state => name => state[name] ?? [],
  },
  mutations: {
    SAVE_STATE(state) {
      localStorage.setItem('store-data', JSON.stringify(state))
    },
    LOAD_STATE(state) {
      const store_data = JSON.parse(localStorage.getItem('store-data'))
      if (store_data) {
        Object.assign(state, store_data)
        localStorage.removeItem('store-data')
      }
    },
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    UPDATE_OPTIONS(state, payload) {
      state[payload.name] = payload.value
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
  },
  actions: {
    async getAdminData({ commit }) {
      const baseApi = process.env.VUE_APP_APIENDPOINT
      const accessToken = localStorage.getItem('accessToken')
      const user = JSON.parse(localStorage.getItem('userData'))

      await axios({
        method: 'GET',
        url: `${baseApi}auth/admin/get-profile/${user.id}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then(json => {
          commit('UPDATE_OPTIONS', { name: 'adminData', value: json.data })
        })
        .catch(error => console.log(error, 'error'))
    },
  },
}
